import * as React from "react";
import { JSX } from "react/jsx-runtime";
const CalenderDownIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.896 9.05537C22.896 9.29015 22.8177 9.52494 22.6221 9.68146L13.621 18.5249C13.2688 18.8771 12.7209 18.8771 12.3687 18.5249L3.36768 9.68145C3.01546 9.32928 3.01546 8.78145 3.36768 8.42928C3.71989 8.07711 4.26778 8.07711 4.62 8.42928L12.9949 16.6467L21.3697 8.39015C21.722 8.03798 22.2698 8.03798 22.6221 8.39015C22.7786 8.62494 22.896 8.82059 22.896 9.05537Z"
      fill="#004E9B"
    />
  </svg>
);
export default CalenderDownIcon;
